import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from 'chart.js';
import theme from '../../constants/Theme';
import { DiaryStatisticDataPoint } from '../../types/diaryTypes';
import { formatDateDayMonth } from '../../helpers/dateHelpers';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface DiaryChartProps {
  history: DiaryStatisticDataPoint[];
}

const DiaryChart: React.FC<DiaryChartProps> = ({ history }) => {
  const chartData = {
    labels: history.map(point => formatDateDayMonth(point.date)),
    datasets: [
      {
        data: history.map(point => point.experience),
        borderColor: theme.colors.blue,
        backgroundColor: theme.colors.blue,
        tension: 0.4,
        pointRadius: 4,
        borderWidth: 2,
      },
    ],
  };

  const chartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      y: {
        min: -0.5,
        max: 5,
        grid: {
          color: theme.colors.blue200,
          lineWidth: 2,
          tickBorderDash: [5, 5],
        },
        border: {
          display: false,
          dash: [5, 5],
        },
        ticks: {
          labelOffset: -10,
          stepSize: 1,
          callback: function (this: any, value: string | number) {
            const labels = ['Eher unangenehm', 'Ausreichend', 'In Ordnung', 'Gut', 'Sehr gut'];
            return labels[Number(value)];
          },
          font: {
            size: 12,
            lineHeight: '16px',
          },
          color: theme.colors.blue200,
          crossAlign: 'near',
          mirror: true,
        },
      },
      x: {
        position: 'bottom',
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        offset: true,
        ticks: {
          padding: 20,
          font: {
            size: 12,
            lineHeight: '16px',
          },
          color: theme.colors.blue,
        },
      },
    },
    layout: {
      padding: {
        bottom: -20,
      },
    },
    backgroundColor: 'transparent',
  };

  return <Line data={chartData} options={chartOptions} />;
};

export default DiaryChart;
